import { useLocation } from 'react-router-dom';
import S from './SettingsPageStyles';
import Tabs from '../../components/common/Tabs/Tabs';
import FleetSettings from './FleetSettings/FleetSettings';
import AlertAudio from './AlertAudio/AlertAudio';
import ThemeSettings from './ThemeSettings/ThemeSettings';

function UsersPage(): JSX.Element {
  const location = useLocation();
  const initialTabId = location.state?.tab ?? undefined;
  const fleetSettingsContent = (): any => (
    <FleetSettings />
  );

  const alertAudioContent = (): any => (
    <AlertAudio />
  );

  const tabsContent = [{
    label: 'Fleet Settings',
    id: 'fleetSettingsTab',
    content: <FleetSettings />,
  }, {
    label: 'Audio Schemas',
    id: 'alertAudioTab',
    content: <AlertAudio />,
  }, {
    label: 'Appearance',
    id: 'appearanceTab',
    content: <ThemeSettings />,
  }];

  return (
    <S.Wrapper>
      <Tabs
        tabs={tabsContent}
        activeId={initialTabId}
      />
    </S.Wrapper>
  );
}

export default UsersPage;
